export const validation = {
  required: "Campo requerido",
  number: "Debe ser un número",
  numberPositive: "Número debe ser positivo",
  numberInteger: "Número debe ser entero",
};
